import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

import {
  type SupervisorInfo,
  type GetSupervisorInfo,
  type SupervisorInvitations,
} from './types';

const GET_SUPERVISOR_INVITATION = gql`
  query ($applicationId: ID!) {
    application(id: $applicationId) {
      programmeChoice {
        acceptedInvitation
        supervisorInvitations {
          key
          value
        }
      }
    }
  }
`;

const GET_SUPERVISOR_INFO = gql`
  query ($netIds: [String!]) {
    advancedUsersInfo(filter: { netIds: $netIds }) {
      netId
      department
      surname
      givenName
      email
    }
  }
`;

export const useGetSupervisorInvitations = (
  applicationId: string | undefined,
): GetSupervisorInfo => {
  // 1. Get have-accepted list and netIds
  const netIdsData = useQuery(GET_SUPERVISOR_INVITATION, {
    variables: { applicationId },
    fetchPolicy: 'network-only',
  });

  let netIds;
  let haveAccepted = false;

  // 2.1. Extract the netIds from invitation
  netIds = (
    netIdsData?.data?.application?.programmeChoice?.supervisorInvitations ?? []
  ).map((el: SupervisorInvitations) => el.key);

  // 2.2 If there are any have-accepted supervisor, replace the netIds with this supervisors' netId, otherwise we keep the netIds from invitation
  const acceptedInvitationNetId =
    netIdsData?.data?.application?.programmeChoice?.acceptedInvitation;
  if (typeof acceptedInvitationNetId === 'string') {
    netIds = [acceptedInvitationNetId];
    haveAccepted = true;
  }

  // 3. Base on the netId(s), get supervisors' detail
  const supervisorInfo = useQuery(GET_SUPERVISOR_INFO, {
    variables: { netIds },
    fetchPolicy: 'network-only',
  });

  // 4. Preprocess supervisor's detail (e.g., surname => SURNAME)
  const prepSupervisorInfo = supervisorInfo.data?.advancedUsersInfo ?? [];
  if (prepSupervisorInfo as boolean) {
    prepSupervisorInfo.forEach((el: SupervisorInfo) => {
      el = { ...el, surname: el.surname?.toUpperCase() };
    });
  }

  return {
    haveAccepted,
    supervisorInfo: prepSupervisorInfo,
    loading: supervisorInfo.loading,
    error: supervisorInfo.error ?? netIdsData.error,
    // Note: Must use netIdsData.refetch to activate changes, supervisorInfo.retched will fail to do so
    refetch: netIdsData.refetch,
  };
};
